module.exports = __webpack_public_path__ + "static/media/aboutimg.fa7ed917.png";